/**
 * Frontend permission helpers.
 *
 * The backend already gives admins bypasses on all quotas/subscription
 * checks. These helpers do the same on the frontend so the UI doesn't show
 * upsell cards, credit warnings, or feature-locked banners to admins — they
 * see the full product exactly as a Pro user would.
 */

/** True when the current user is an admin. Handles null/undefined safely. */
export function isAdmin(user) {
  return !!(user && user.role === "admin");
}

/**
 * True when the user should have unlimited access to premium features.
 * Covers admins and any Pro/Amateur subscriber.
 */
export function hasUnlimitedAccess(user) {
  if (!user) return false;
  if (user.role === "admin") return true;
  if (user.subscription_active) return true;
  return false;
}
